import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Styling
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
// import 'bootstrap/dist/js/bootstrap.min.js';
import Maintenance from './Maintenance';
import { AuthProvider } from './context/AuthContext';
import { registerGlobalErrorHandler } from './utils/globalErrorHandler';
import ErrorBoundary from './Components/ErrorBoundary';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

registerGlobalErrorHandler();

// Environment banner: surface which backend this build points to.
const BACKEND_URL = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}`;
const APP_ENV = String(process.env.REACT_APP_HOST || '').includes('staging')
  ? 'STAGING'
  : 'PRODUCTION';
console.info(
  `%c CLP • ${APP_ENV} `,
  'background:#f59e0b;color:#111;font-weight:bold;padding:2px 6px;border-radius:4px',
  `\nBackend API : ${BACKEND_URL}\nApp URL     : ${process.env.REACT_APP_URL}`,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        {/* <Maintenance /> */}
        <App />
      </BrowserRouter>
    </AuthProvider>
  </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
